import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../utils/imageUrl";

function formatBlogDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}

function BlogPost({
    blogID,
    blogImage,
    blogTitle,
    authorName,
    publishedAt,
    location,
    excerpt,
}) {
    const image = getImageUrl(blogImage, "blog");
    const published = formatBlogDate(publishedAt);

    return (
        <div className="th-blog blog-single has-post-thumbnail">
            {image && (
                <div className="blog-img">
                    <Link to={`/blog/${blogID}`}>
                        <img src={image} alt={blogTitle || "Blog"} />
                    </Link>
                </div>
            )}
            <div className="blog-content">
                <div className="blog-meta">
                    {authorName && (
                        <span className="author">
                            <i className="fa-light fa-user" />
                            by {authorName}
                        </span>
                    )}
                    {published && (
                        <span>
                            <i className="fa-solid fa-calendar-days" />
                            {published}
                        </span>
                    )}
                    {location && (
                        <span>
                            <img src="/assets/img/icon/map.svg" alt="" />
                            {location}
                        </span>
                    )}
                </div>
                <h2 className="blog-title">
                    <Link to={`/blog/${blogID}`}>{blogTitle}</Link>
                </h2>
                {excerpt && <p className="blog-text">{excerpt}</p>}
                <Link to={`/blog/${blogID}`} className="th-btn style4 th-icon">
                    Read More
                </Link>
            </div>
        </div>
    );
}

export default BlogPost;
